<mat-form-field
  *ngIf="dateAggregationType | async"
  appearance="fill"
  class="mat-form-field--no-label mat-form-field--no-errors"
  data-cy="select-date-range-filter">
  <mat-select
    (selectionChange)="updated($event)"
    [(ngModel)]="dateRange"
    [disabled]="(dateAggregationType | async) === clientDateAggregationType.MONTHLY"
    class="date-range"
    panelClass="select-date-range-panel">
    <ng-container *ngIf="(dateAggregationType | async) === clientDateAggregationType.DAILY">
      <mat-option [value]="dateRangeType.ONE_WEEK">{{dateRangeType.ONE_WEEK | translate}}</mat-option>
      <mat-option [value]="dateRangeType.FOUR_WEEKS">{{dateRangeType.FOUR_WEEKS | translate}}</mat-option>
      <mat-option [value]="dateRangeType.TWELVE_WEEKS">{{dateRangeType.TWELVE_WEEKS | translate}}</mat-option>
    </ng-container>

    <ng-container *ngIf="(dateAggregationType | async) === clientDateAggregationType.MONTHLY">
      <mat-option [value]="dateRangeType.LAST_THREE_MONTHS">{{dateRangeType.LAST_THREE_MONTHS | translate}}</mat-option>
    </ng-container>

    <ng-container *ngIf="(dateAggregationType | async) === clientDateAggregationType.WEEKLY">
      <mat-option [value]="dateRangeType.FOUR_WEEKS">{{dateRangeType.FOUR_WEEKS | translate}}</mat-option>
      <mat-option [value]="dateRangeType.TWELVE_WEEKS">{{dateRangeType.TWELVE_WEEKS | translate}}</mat-option>
      <mat-option [value]="dateRangeType.LAST_FOUR_WEEKS">{{dateRangeType.LAST_FOUR_WEEKS | translate}}</mat-option>
      <mat-option [value]="dateRangeType.LAST_TWELVE_WEEKS">{{dateRangeType.LAST_TWELVE_WEEKS | translate}}</mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>
